import Tools from './../components/tools';

export default class ConventionsContrats {
  constructor() {
    // Template conventions contrats
    this.manageSubCategories();
    this.manageAccordions();
  }

  manageSubCategories() {
    const subCategories = document.querySelectorAll('.header .categories li');
    if (subCategories.length > 0) {
      subCategories.forEach((category) => {
        category.addEventListener('click', () => {
          if (document.querySelector('.header .categories li.active')) {
            document.querySelector('.header .categories li.active').classList.remove('active');
          }
          category.classList.add('active');
          document.querySelector('.categories-container .category-wrapper.active').classList.remove('active');
          document.querySelector(`.categories-container .category-wrapper[data-tab="${category.dataset.tab}"]`).classList.add('active');
        });
      });
    }
  }

  manageAccordions() {
    const accordions = document.querySelectorAll('.categories-container .category-wrapper .sub-category-wrapper');
    if (accordions.length > 0) {
      accordions.forEach((accordion) => {
        accordion.querySelector('h3').addEventListener('click', () => {
          accordion.classList.toggle('open');

          if (accordion.classList.contains('open')) {
            Tools.zeroToAuto(accordion.querySelector('.documents'));
          } else {
            Tools.autoToZero(accordion.querySelector('.documents'));
          }
        });
      });
    }
  }
}